import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../utils/dateFormat';

const fmt = (n) => (Number(n) || 0).toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function ZReportView({ report, shiftNumber, kkmName }) {
    const { t } = useTranslation('cashier');
    if (!report) return null;
    const pm = report.byPaymentMethod || {};
    const revenue = fmt((report.receipts?.total || 0) - (report.refunds?.total || 0));
    return (
        <div className="z-report">
            <p style={{ color: 'var(--pos-muted)', margin: '0 0 12px' }}>
                {formatDate(new Date())} · {t('zReport.shiftLine', { num: shiftNumber })}
                {kkmName && <> · {kkmName}</>}
            </p>
            <div style={{ borderTop: '2px solid var(--pos-border)', paddingTop: 12, marginBottom: 16 }}>
                <div style={{ fontSize: 22, fontWeight: 700 }}>{t('zReport.revenue', { amount: revenue })}</div>
            </div>
            <p style={{ fontWeight: 600, marginBottom: 8 }}>{t('zReport.byPaymentMethod')}</p>
            <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 16px' }}>
                <li>{t('zReport.cash', { amount: fmt(pm.cash) })}</li>
                <li>{t('zReport.card', { amount: fmt(pm.card) })}</li>
                <li>{t('zReport.sbp', { amount: fmt(pm.sbp) })}</li>
                <li>{t('zReport.bonus', { amount: fmt(pm.bonus) })}</li>
            </ul>
            <p>{t('zReport.receiptsCount', { count: report.receipts?.count ?? 0 })}</p>
            <p>{t('zReport.refundsCount', { count: report.refunds?.count ?? 0 })}</p>
            <p>{t('zReport.closingBalance', { amount: fmt(report.closingBalance) })}</p>
        </div>
    );
}
